import React from 'react';
import Pageheader from '../utils/headerHelment';
import ProjectInformationPage from '../components/ProjectInformation/ProjectInformationPage';

const ProjectInformationView = () => {
    return (
        <>
            <Pageheader title="LENS - Project Information" />
            <ProjectInformationPage />
        </>
    );
};

export default ProjectInformationView;
